/**
 * @generated SignedSource<<5dc3fb10e9bc28bb236d1c374ec578e4>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';

export type AddressChallengePageQuery$variables = {
  identityId: string;
};
export type AddressChallengePageQuery$data = {
  readonly addressChallenge: {
    readonly addresses: ReadonlyArray<{
      readonly id: string;
      readonly locality: string;
      readonly primaryAddressLine: string;
      readonly secondaryAddressLine: string | null;
      readonly subdivision: string;
      readonly zip: string;
      readonly ' $fragmentSpreads': FragmentRefs<'AddressCellFragment'>;
    }>;
  };
};
export type AddressChallengePageQuery = {
  response: AddressChallengePageQuery$data;
  variables: AddressChallengePageQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'identityId',
      },
    ],
    v1 = [
      {
        fields: [
          {
            kind: 'Variable',
            name: 'identityId',
            variableName: 'identityId',
          },
        ],
        kind: 'ObjectValue',
        name: 'q',
      },
    ],
    v2 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v3 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'primaryAddressLine',
      storageKey: null,
    },
    v4 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'secondaryAddressLine',
      storageKey: null,
    },
    v5 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'locality',
      storageKey: null,
    },
    v6 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'subdivision',
      storageKey: null,
    },
    v7 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'zip',
      storageKey: null,
    };
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'AddressChallengePageQuery',
      selections: [
        {
          alias: null,
          args: v1 /*: any*/,
          concreteType: 'AddressChallengeResponse',
          kind: 'LinkedField',
          name: 'addressChallenge',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Address',
              kind: 'LinkedField',
              name: 'addresses',
              plural: true,
              selections: [
                v2 /*: any*/,
                {
                  args: null,
                  kind: 'FragmentSpread',
                  name: 'AddressCellFragment',
                },
                v3 /*: any*/,
                v4 /*: any*/,
                v5 /*: any*/,
                v6 /*: any*/,
                v7 /*: any*/,
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'AddressChallengePageQuery',
      selections: [
        {
          alias: null,
          args: v1 /*: any*/,
          concreteType: 'AddressChallengeResponse',
          kind: 'LinkedField',
          name: 'addressChallenge',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Address',
              kind: 'LinkedField',
              name: 'addresses',
              plural: true,
              selections: [v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/, v7 /*: any*/],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
    },
    params: {
      cacheID: '7fb10c8f5ac757ddadbdb124cd0aa64e',
      id: null,
      metadata: {},
      name: 'AddressChallengePageQuery',
      operationKind: 'query',
      text: 'query AddressChallengePageQuery(\n  $identityId: String!\n) {\n  addressChallenge(q: {identityId: $identityId}) {\n    addresses {\n      id\n      ...AddressCellFragment\n      primaryAddressLine\n      secondaryAddressLine\n      locality\n      subdivision\n      zip\n    }\n  }\n}\n\nfragment AddressCellFragment on Address {\n  id\n  primaryAddressLine\n  secondaryAddressLine\n  locality\n  subdivision\n  zip\n}\n',
    },
  };
})();

(node as any).hash = 'dd891eabd9a725bf9c8c32eec6cea2c7';

export default node;
